import React from "react";
import { Form, Row, Col } from "antd";
import ControlledInput from "../../components/Backoffice/ControlledInput";
import ControlledDatePicker from "../../components/Backoffice/ControlledDatePicker";
import ControlledSelect from "../../components/Backoffice/ControlledSelectV1";

const EditPurchaseDetailsForm = ({ control, errors, variantField }) => {
  const currentDate = new Date();
  return (
    <Form colon={false}>
      <>
        {variantField.includes("nameOfTheShop") && (
          <Row gutter={24}>
            <Col span={24}>
              <ControlledInput
                required
                control={control}
                name="nameOfTheShop"
                label="Name of Shop"
                errors={errors}
              />
            </Col>
          </Row>
        )}
        {variantField.includes("addressOfTheShop") && (
          <Row gutter={24}>
            <Col span={24}>
              <ControlledInput
                required
                control={control}
                name="addressOfTheShop"
                label="Address of Shop"
                errors={errors}
              />
            </Col>
          </Row>
        )}
        {variantField.includes("dateOfPurchase") && (
          <Row gutter={24}>
            <Col span={24}>
              <ControlledDatePicker
                required
                control={control}
                format="DD-MM-YYYY"
                showTime={true}
                name="dateOfPurchase"
                label="Date of Purchase"
                errors={errors}
                maximum={new Date(currentDate.getTime())}
              />
            </Col>
          </Row>
        )}
        {variantField.includes("quantityOfSample") && (
          <Row gutter={24}>
            <Col span={24}>
              <ControlledInput
                required
                control={control}
                name="quantityOfSample"
                label="Sample Weight (grams)"
                errors={errors}
              />
            </Col>
          </Row>
        )}
        {variantField.includes("costOfSample") && (
          <Row gutter={24}>
            <Col span={24}>
              <ControlledInput
                required
                control={control}
                name="costOfSample"
                label="Sample Cost in ₹"
                errors={errors}
              />
            </Col>
          </Row>
        )}
      </>

      {variantField.includes("typeOfShop") && (
        <Row gutter={24}>
          <Col span={24}>
            <ControlledSelect
              required
              control={control}
              name="typeOfShop"
              label="Type of Shop"
              errors={errors}
              options={[
                { label: "Retail", value: "Retail" },
                { label: "Kirana Shop", value: "Kirana Shop" },
                { label: "Supermarket", value: "Supermarket" },
                { label: "Mandi", value: "Mandi" },
                { label: "Street Vendor", value: "Street Vendor" },
              ]}
            />
          </Col>
        </Row>
      )}
    </Form>
  );
};

export default EditPurchaseDetailsForm;
